export default __webpack_public_path__ + "assets/13937c426ebb991cf8838caf04d58590.jpg";